.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_gz_ftgil2.atm_gz_ftgil2{margin-left:8px;}
.atm_gz_exct8b.atm_gz_exct8b{margin-left:16px;}
.atm_gi_1s5ai0k{margin:0 5px;}
